import { instantsInterceptor, } from '@/api/index';

function getMyQnaList(searchObj) {
    return instantsInterceptor.post('/service/mylibrary/myqna/list', searchObj);
}

export { getMyQnaList };